// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"cfb38b01","498":"f9393a3f","703":"56bc3884"}[chunkId] + ".chunk.js";
};